import UnSubscribedLayout from './UnSubscribedLayout';

export default UnSubscribedLayout;
